const GUEST_IDENTITY_KEY = 'nblog_guest_identity_v1'
const GUEST_AVATAR_COUNT = 40
const GUEST_NICKNAME_PREFIX = '访客'

const GUEST_AVATAR_POOL = Array.from({length: GUEST_AVATAR_COUNT}, (_, index) => `/img/guest-avatar/${index + 1}.svg`)

function randomText(length = 4) {
	const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'
	let result = ''
	for (let i = 0; i < length; i++) {
		result += chars.charAt(Math.floor(Math.random() * chars.length))
	}
	return result
}

function randomFrom(array) {
	return array[Math.floor(Math.random() * array.length)]
}

function normalizeGuestIdentity(identity) {
	if (!identity || typeof identity !== 'object') {
		return null
	}
	if (!identity.id || !identity.nickname || !identity.avatar || !identity.email) {
		return null
	}
	if (!GUEST_AVATAR_POOL.includes(identity.avatar)) {
		return null
	}
	return identity
}

export function createGuestIdentity() {
	const suffix = randomText(4)
	return {
		id: `guest_${Date.now().toString(36)}_${randomText(6)}`,
		nickname: `${GUEST_NICKNAME_PREFIX}${suffix}`,
		avatar: randomFrom(GUEST_AVATAR_POOL),
		email: `guest_${suffix.toLowerCase()}@nblog.local`,
		website: '',
		createdAt: Date.now(),
	}
}

export function getGuestIdentity() {
	try {
		const raw = window.localStorage.getItem(GUEST_IDENTITY_KEY)
		if (raw) {
			const parsed = JSON.parse(raw)
			const normalized = normalizeGuestIdentity(parsed)
			if (normalized) {
				return normalized
			}
		}
	} catch (e) {
		// ignore parse error and regenerate identity
	}
	const identity = createGuestIdentity()
	window.localStorage.setItem(GUEST_IDENTITY_KEY, JSON.stringify(identity))
	return identity
}

export function resetGuestIdentity() {
	const identity = createGuestIdentity()
	window.localStorage.setItem(GUEST_IDENTITY_KEY, JSON.stringify(identity))
	return identity
}

export function getCommentIdentity() {
	const token = window.localStorage.getItem('adminToken') || ''
	if (token) {
		return {
			isLoggedIn: true,
			token,
			nickname: window.localStorage.getItem('nickname') || window.localStorage.getItem('username') || '管理员',
			avatar: window.localStorage.getItem('userAvatar') || '/img/avatar.jpg',
			email: window.localStorage.getItem('email') || 'admin@nblog.local',
			website: '',
		}
	}
	const guest = getGuestIdentity()
	return {
		isLoggedIn: false,
		token: '',
		nickname: guest.nickname,
		avatar: guest.avatar,
		email: guest.email,
		website: guest.website,
	}
}

export function getGuestAvatarPool() {
	return GUEST_AVATAR_POOL.slice()
}
